import React, { Component } from 'react'
import { connect } from 'react-redux';
import '../App.css';

import List from '@material-ui/core/List';

import DialogAction from '../componets/DialogAction.jsx';
import DialogPanel from '../componets/DialogPanel.jsx';

import * as ZoneActions from '../actions/Actions_ZoneManager';

import ZoneCard from '../containers/Zone/ZoneCard';
import ZoneListPanel from '../containers/Zone/ZoneListPanel';
import { init_zone } from '../constant/initState/initZone';

import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../common/SetTime.js';

let ZoneList = [];
let waitingTime = true;
const _height = (window.innerHeight - 130);

class ZoneManage extends Component {
    state = { isLoading: true, msgError: undefined, dialogType: undefined, }
    constructor(props) {
        let error = null;
        super(props);
        this.state = {
            ZoneInfo: undefined,
            oldZoneInfo: null,
            isCreate: false,
            isEdit: false,
            isView: false,
        }
        this.props.getZoneList({ num_limit: 10 });
    }

    componentWillReceiveProps(nextProps) {
        const { ZoneManager } = nextProps;
        if (!!ZoneManager) {

            const { actions, data } = ZoneManager.ZONE_REDUCER;

            switch (actions) {
                case ZoneActions.GET_ZONE_SUCCESS:
                    {
                        ZoneList = data.result;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case ZoneActions.GET_ZONE_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
            }
        }
    }

    render() {
        const { isLoading, isCreate } = this.state;
        return (
            <div className="App">
                {(isCreate) && <DialogAction Active={isCreate} OnClose={this.onClosePanel} AcrionCom={this.createZone()} />}
                {(isLoading) && <DialogPanel Active={isLoading} />}
                <List style={{ width: '100%', position: 'relative', overflow: 'auto', height: _height }}>
                    <div style={{ display: 'inline-block' }}>
                        {this.contentPanel()}
                    </div>
                </List>
            </div>
        )
    }
    contentPanel() {
        return (
            <div style={{ height: '600px', width: '100%', maxWidth: '1024px', }}>
                <ZoneListPanel
                    ZoneList={ZoneList}
                    CreatePanel={this.onCreatePanel(this.state.isCreate)}
                    EditInfo={this.editPanel()}
                    ViewInfo={this.viewInfo()} />
            </div>)
    }

    createZone = () => {
        const { isEdit, ZoneInfo, oldZoneInfo, isView } = this.state;
        return (
            <ZoneCard
                ZoneList={ZoneList}
                onChangeLanguage={this.onChangeLanguage}
                isEdit={isEdit}
                isView={isView}
                ZoneInfo={ZoneInfo}
                oldZoneInfo={oldZoneInfo}
                onClosePanel={this.onClosePanel}
            />
        )
    }

    onCreatePanel = (_isActive) => () => (this.setState({ isCreate: !_isActive, isEdit: false, isView: false, oldZoneInfo: { ...init_zone }, ZoneInfo: { ...init_zone } }));
    onClosePanel = () => (this.setState({ isCreate: false, isEdit: false, isView: false, ZoneInfo: undefined, }));
    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined }));

    onChangeLanguage = (_language) => {
        const { page } = ZoneList;
        // console.log('_language', _language);
        this.props.getZoneList({ page: page, num_limit: 10, language: _language });
    }

    editPanel = () => (ZoneInfo) => {
        this.setState({
            isCreate: true,
            isEdit: true,
            isView: false,
            ZoneInfo,
            oldZoneInfo: ZoneInfo
        })
    }

    viewInfo = () => (ZoneInfo) => {
        this.setState({
            isCreate: true,
            isView: true,
            ZoneInfo,
            oldZoneInfo: ZoneInfo
        })
    }

}
function mapStateToProps(state, ownProps) {
    return { ...state };
}

function mapDispatchToProps(dispatch) {
    return {
        getZoneList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(ZoneActions.getZoneList(_keyword, _filter));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ZoneManage);